/**
 * Frame-based time utilities.
 *
 * All times in the editor are stored as seconds (float).
 * These utilities snap to the nearest frame boundary and
 * convert between seconds, frames, and timecode strings.
 */

/** Snap a time (seconds) to the nearest frame boundary */
export function snapToFrame(time: number, frameRate: number): number {
  return Math.round(time * frameRate) / frameRate;
}

/** Convert seconds to frame number */
export function timeToFrame(time: number, frameRate: number): number {
  return Math.round(time * frameRate);
}

/** Convert frame number to seconds */
export function frameToTime(frame: number, frameRate: number): number {
  return frame / frameRate;
}

/**
 * Format time as AE-style timecode: HH:MM:SS:FF
 * where FF is the frame number within the current second.
 */
export function formatTimecode(time: number, frameRate: number): string {
  const totalFrames = Math.round(time * frameRate);
  const ff = totalFrames % frameRate;
  const totalSeconds = Math.floor(totalFrames / frameRate);
  const ss = totalSeconds % 60;
  const totalMinutes = Math.floor(totalSeconds / 60);
  const mm = totalMinutes % 60;
  const hh = Math.floor(totalMinutes / 60);

  const pad2 = (n: number) => n.toString().padStart(2, '0');
  return `${pad2(hh)}:${pad2(mm)}:${pad2(ss)}:${pad2(ff)}`;
}

/**
 * Get the frame duration (seconds per frame).
 * E.g., at 24fps: 1/24 = 0.041666...
 */
export function frameDuration(frameRate: number): number {
  return 1 / frameRate;
}
